import { toRomaji } from 'wanakana'

export function slugify(text: string): string {
  return toRomaji(text)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
}

export function goalSlug(title: string, id: string): string {
  return `${slugify(title)}-${id}`
}

export function goalUrl(title: string, id: string): string {
  return `/goals/${goalSlug(title, id)}`
}

export function slugFromGoalTitle(text: string): string {
  return slugify(text.trim()).slice(0, 200)
}

export function goalTitleFromSlug(slug: string): string {
  const words = slug.split('-').filter(Boolean).join(' ')
  return words.charAt(0).toUpperCase() + words.slice(1)
}

export function titleFromGoalSlug(slug: string): string {
  const words = slug.split('-').slice(0, -1)
  if (!words.length) return 'Goal'
  return words.map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
}

export function formatCount(n: number): string {
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`
  return String(n)
}
